import absoluteUrl from 'next-absolute-url'

import VoucherDetail from 'containers/VoucherDetail'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { getVoucherByCodeApi } from 'services/promotion'

export default function Index({ canonical, voucherdata, isShowPromocode }) {
  const metaTitle = '24 FIX | Vouchers'
  const metaDescription = '24 FIX | Vouchers'

  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} pathUrl={canonical} />

      <Layout>
        <VoucherDetail voucherdata={voucherdata} isShowPromocode={isShowPromocode} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req, res, query } = context
  const { origin } = absoluteUrl(req)
  const { slug, promo } = query

  const voucherdata = await getVoucherByCodeApi(slug).then(res => res.data.data?.[0])

  res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=59')

  return {
    props: JSON.parse(
      JSON.stringify({
        voucherdata,
        isShowPromocode: promo === 'true',
        canonical: `${origin}/voucher/${slug}`,
      })
    ),
  }
}
